var moduleMap = {
	"./Shell": () => {
		return Promise.all([__webpack_require__.e(679), __webpack_require__.e(7929), __webpack_require__.e(4623), __webpack_require__.e(5064), __webpack_require__.e(1925), __webpack_require__.e(4037), __webpack_require__.e(7314), __webpack_require__.e(1495), __webpack_require__.e(5805), __webpack_require__.e(5010), __webpack_require__.e(97), __webpack_require__.e(4053), __webpack_require__.e(4914), __webpack_require__.e(4188), __webpack_require__.e(632), __webpack_require__.e(6672), __webpack_require__.e(1985), __webpack_require__.e(7705), __webpack_require__.e(7827), __webpack_require__.e(4478), __webpack_require__.e(1881), __webpack_require__.e(2159), __webpack_require__.e(9224)]).then(() => (() => ((__webpack_require__(94553)))));
	},
	"./components": () => {
		return __webpack_require__.e(9981).then(() => (() => ((__webpack_require__(29981)))));
	},
	"./hooks": () => {
		return __webpack_require__.e(1405).then(() => (() => ((__webpack_require__(51405)))));
	},
	"./router": () => {
		return Promise.all([__webpack_require__.e(7929), __webpack_require__.e(5096)]).then(() => (() => ((__webpack_require__(90849)))));
	},
	"./SvgAvatar": () => {
		return __webpack_require__.e(652).then(() => (() => ((__webpack_require__(70652)))));
	},
	"./restClient": () => {
		return Promise.all([__webpack_require__.e(679), __webpack_require__.e(7929), __webpack_require__.e(4623), __webpack_require__.e(4037), __webpack_require__.e(1495), __webpack_require__.e(4053), __webpack_require__.e(4914), __webpack_require__.e(632), __webpack_require__.e(6672), __webpack_require__.e(1985), __webpack_require__.e(7705), __webpack_require__.e(4478), __webpack_require__.e(5517)]).then(() => (() => ((__webpack_require__(52947)))));
	},
	"./useUser": () => {
		return Promise.all([__webpack_require__.e(4188), __webpack_require__.e(2391)]).then(() => (() => ((__webpack_require__(42391)))));
	},
	"./useHasPermission": () => {
		return Promise.all([__webpack_require__.e(5064), __webpack_require__.e(4914), __webpack_require__.e(4188), __webpack_require__.e(7337)]).then(() => (() => ((__webpack_require__(77337)))));
	},
	"./i18n": () => {
		return Promise.all([__webpack_require__.e(5010), __webpack_require__.e(1881), __webpack_require__.e(5024)]).then(() => (() => ((__webpack_require__(32024)))));
	},
	"./icons": () => {
		return Promise.all([__webpack_require__.e(679), __webpack_require__.e(4623), __webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(3620)]).then(() => (() => ((__webpack_require__(73620)))));
	},
	"./constants": () => {
		return __webpack_require__.e(8136).then(() => (() => ((__webpack_require__(98136)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});